const SettingsOptionRenderer = {
  SETTINGS: 'Settings',
  SETTINGS_UNAVAILABLE_TODAY: 'SettingsUnavailableToday',
  SETTINGS_ONLY_TODAY: 'SettingsOnlyToday',
};

export default SettingsOptionRenderer;
